var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Navigator__Icn/40px/Navigator",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Navigator__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Navigator__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,9 C26.0751322,9 31,13.9248678 31,20 C31,26.0751322 26.0751322,31 20,31 C13.9248678,31 9,26.0751322 9,20 C9,13.9248678 13.9248678,9 20,9 Z M20,11 C15.0294373,11 11,15.0294373 11,20 C11,24.9705627 15.0294373,29 20,29 C24.9705627,29 29,24.9705627 29,20 C29,15.0294373 24.9705627,11 20,11 Z M20,12 L23.998,19.999 L20,28 L16,20 L20,12 Z M22,20 L18,20 L20.0120928,24.3206635 L22,20 Z",
    id: ".._.._src_svg_Icn_40px_Navigator__Combined-Shape",
    transform: "rotate(30 20 20)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigator);
export default __webpack_public_path__ + "static/media/Navigator.4d59e85da61a0feee1f774f6643adcd8.svg";
export { ForwardRef as ReactComponent };